import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/@core/services/auth.service';
import { RedirectParameter } from '../model/redirect-parameter.model';
import { AuthorizationService } from 'src/app/@core/services/authorization.service';

@Injectable({
  providedIn: 'root'
})
export class NavegationService {

  public Event: any = new EventEmitter<any>();
  private _params: Array<RedirectParameter>;
  private _module: string;
  private urlCompany: any;

  constructor(
    private router: Router,
    private authService: AuthService,
    private authorizationService: AuthorizationService
  ) {
    this._params = new Array<RedirectParameter>();
  }

  public addParameter(module: string, parameter: RedirectParameter): void {
    if (this._module !== module)
      this._params = new Array<RedirectParameter>();

    this._module = module;

    var parameterExist = this._params.find(x => x.name == parameter.name);

    if (parameterExist !== undefined)
      parameterExist.value = parameter.value;
    else
      this._params.push(parameter);
  }

  public redirect(): void {

    switch (this._module) {
      case "customer":
        this.RedirectCustomer();
        break;
      case "quote":
        this.RedirectQuote();
        break;
      case "order":
        this.RedirectOrder();
        break;
      case "factory":
        this.RedirectFactory();
        break;
      case "revenue":
        this.RedirectRevenue();
        break;
      case "manufacturing-order":
        this.RedirectManufacturingOrder();
        break;
      case "request":
        this.RedirectRequest();
        break;
      case "contract":
        this.RedirectContract();
        break;
      case "packing-list":
        this.RedirectPackingList();
        break;
      case "packing":
        this.RedirectPacking();
        break;
      case "collection-request":
        this.RedirectCollectionRequest();
        break;
      case "document-export":
        this.RedirectDocumentExport();
        break;
      case "visit-report":
        this.RedirectReportList();
        break;
      case "bom":
        this.RedirectBOM();
        break;
      case "receiving":
        this.RedirectReceiving();
        break;
      case "drawback":
        this.RedirectDrawback();
        break;
      case "conformity-certificate":
        this.RedirectConformityCertificate();
        break;
      case "teadit-store":
        this.RedirectTeaditStore();
        break;
      case "embalagens":
        this.RedirectEmbalagens();
        break;
      case "opportunity":
        this.RedirectOpportunity();
        break;
      case "customer-date-change":
        this.RedirectCustomerDateChange();
        break;
    }
  }

  private RedirectCustomer(): void {

    let urlStatus = 'all';
    let urlMarket = this.authService.getClaims().MarketDefault;

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "market") !== undefined)
      urlMarket = this._params.find(x => x.name == "market").value;

    this.router.navigateByUrl(`customer/panel/market/${urlMarket}/status/${urlStatus}`)
  }

  private RedirectReceiving(): void {

    if (this._params.find(x => x.name == "company") !== undefined)
      this.urlCompany = this._params.find(x => x.name == "company").value;
    else
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    this.router.navigateByUrl(`receiving/company/${this.urlCompany}`)
  }

  private RedirectDrawback(): void {
    if (this._params.find(x => x.name == "company") !== undefined)
      this.urlCompany = this._params.find(x => x.name == "company").value;
    else
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    let urlStatus = 'all';
    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    this.router.navigateByUrl(`drawback/panel/company/${this.urlCompany}/status/${urlStatus}`);
  }

  private RedirectContract(): void {

    let urlMarket = this.authService.getClaims().MarketDefault;
    let urlStatus = 'all';
    let urlFilter = 'all';
    let urlValue = 'all';
    let tipoDocumento = 'contrato';

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "market") !== undefined)
      urlMarket = this._params.find(x => x.name == "market").value;

    if (this._params.find(x => x.name == "company") !== undefined)
      this.urlCompany = this._params.find(x => x.name == "company").value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this._params.find(x => x.name == "filter") !== undefined)
      urlFilter = this._params.find(x => x.name == "filter").value;

    if (this._params.find(x => x.name == "value") !== undefined)
      urlValue = this._params.find(x => x.name == "value").value;

    if (this._params.find(x => x.name == "doc-type") !== undefined)
      tipoDocumento = this._params.find(x => x.name == "doc-type").value;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    this.router.navigateByUrl(`contract/panel/company/${this.urlCompany}/market/${urlMarket}/status/${urlStatus}/filter/${urlFilter}/value/${urlValue}/doc-type/${tipoDocumento}`)

  }

  private RedirectPackingList(): void {
    let urlStatus = 'all';

    if (this._params.find((x) => x.name == 'status') !== undefined)
      urlStatus = this._params.find((x) => x.name == 'status').value;

    if (this._params.find((x) => x.name == 'company') !== undefined)
      this.urlCompany = this._params.find((x) => x.name == 'company').value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    this.router.navigateByUrl(
      `packing-list/panel/status/${urlStatus}/company/${this.urlCompany}`
    );
  }

  private RedirectBOM(): void {
    let urlStatus = 'all';
    let urlLineOfProduction = this.authService.getClaims().IdLineOfProductSelected;

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "lineOfProduction") !== undefined)
      urlLineOfProduction = this._params.find(x => x.name == "lineOfProduction").value;

    if (this._params.find(x => x.name == "company") !== undefined)
      this.urlCompany = this._params.find(x => x.name == "company").value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    if (urlLineOfProduction !== this.authService.getClaims().IdLineOfProductSelected)
      this.authorizationService.selectLineOfProduct(urlLineOfProduction);

    this.router.navigateByUrl(`bom/panel/status/${urlStatus}/company/${this.urlCompany}/lineOfProduction/${urlLineOfProduction}`);
  }

  private RedirectReportList(): void {
    let urlMarket = this.authService.getClaims().MarketDefault;

    if (this._params.find(x => x.name == "market") !== undefined)
      urlMarket = this._params.find(x => x.name == "market").value;

    this.router.navigateByUrl(`visit-report/panel/market/${urlMarket}`);
  }

  private RedirectCollectionRequest(): void {
    let urlStatus = 'all';

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "company") !== undefined)
      this.urlCompany = this._params.find(x => x.name == "company").value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    this.router.navigateByUrl(`collection-request/panel/status/${urlStatus}/company/${this.urlCompany}`);
  }

  private RedirectDocumentExport(): void {
    let urlStatus = 'all';

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "company") !== undefined
      && this._params.find(x => x.name == "company").value !== 'null'
      && this._params.find(x => x.name == "company").value !== 'all')
      this.urlCompany = this._params.find(x => x.name == "company").value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    this.router.navigateByUrl(`document-export/panel/status/${urlStatus}/company/${this.urlCompany}`);
  }

  private RedirectPacking(): void {
    let urlMarket = this.authService.getClaims().MarketDefault.trim().length > 0 ? this.authService.getClaims().MarketDefault : 'MI';
    let urlCompany = this.authService.getClaims().Companies.length > 0 ? this.authService.getClaims().IdCompanySelected : 'all';
    let urlStatus = '2';
    let urlLineOfProduction = this.authService.getClaims().LineOfProducts.length > 0 ? this.authService.getClaims().IdLineOfProductSelected : 'all';

    if (this._params.find(x => x.name == "market") !== undefined && this._params.find(x => x.name == "market").value.trim().length > 0)
      urlMarket = this._params.find(x => x.name == "market").value;

    if (this._params.find(x => x.name == "company") !== undefined && this._params.find(x => x.name == "company").value !== 'all')
      urlCompany = this._params.find(x => x.name == "company").value;

    if (this._params.find(x => x.name == "status") !== undefined && this._params.find(x => x.name == "status").value !== 'all')
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "lineOfProduction") !== undefined)
      urlLineOfProduction = this._params.find(x => x.name == "lineOfProduction").value;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    if (urlLineOfProduction !== this.authService.getClaims().IdLineOfProductSelected)
      this.authorizationService.selectLineOfProduct(urlLineOfProduction);

    this.router.navigateByUrl(`packing/panel/market/${urlMarket}/company/${urlCompany}/status/${urlStatus}/lineOfProduction/${urlLineOfProduction}`);
  }

  private RedirectQuote(): void {

    let urlMarket = this.authService.getClaims().MarketDefault;
    let urlCompanyGroup = 'all';
    let urlVisibility = 'all';
    let urlStatus = 'all';
    let urlMonth = 'all';

    if (this._params.find(x => x.name == "market") !== undefined)
      urlMarket = this._params.find(x => x.name == "market").value;

    if (this._params.find(x => x.name == "company-group") !== undefined)
      urlCompanyGroup = this._params.find(x => x.name == "company-group").value;

    if (this._params.find(x => x.name == "visibility") !== undefined)
      urlVisibility = this._params.find(x => x.name == "visibility").value;

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "month") !== undefined)
      urlMonth = this._params.find(x => x.name == "month").value;

    this.router.navigateByUrl(`quote/panel/market/${urlMarket}/company-group/${urlCompanyGroup}/visibility/${urlVisibility}/status/${urlStatus}/month/${urlMonth}`);
  }

  private RedirectOrder(): void {

    let urlMarket = this.authService.getClaims().MarketDefault;
    let urlCompanyGroup = 'all';
    let urlVisibility = 'all';
    let urlStatus = 'all';
    let urlMonth = 'all';

    if (this._params.find(x => x.name == "market") !== undefined)
      urlMarket = this._params.find(x => x.name == "market").value;

    if (this._params.find(x => x.name == "company-group") !== undefined)
      urlCompanyGroup = this._params.find(x => x.name == "company-group").value;

    if (this._params.find(x => x.name == "visibility") !== undefined)
      urlVisibility = this._params.find(x => x.name == "visibility").value;

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "month") !== undefined)
      urlMonth = this._params.find(x => x.name == "month").value;

    this.router.navigateByUrl(`order/panel/market/${urlMarket}/company-group/${urlCompanyGroup}/visibility/${urlVisibility}/status/${urlStatus}/month/${urlMonth}`)
  }

  private RedirectFactory(): void {
    let urlStatus = 'all';
    let urlLineOfProduction = this.authService.getClaims().IdLineOfProductSelected;

    if (this._params.find(x => x.name == "company") !== undefined && this._params.find(x => x.name == "company").value !== 'all')
      this.urlCompany = this._params.find(x => x.name == "company").value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "lineOfProduction") !== undefined)
      urlLineOfProduction = this._params.find(x => x.name == "lineOfProduction").value;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    if (urlLineOfProduction !== this.authService.getClaims().IdLineOfProductSelected)
      this.authorizationService.selectLineOfProduct(urlLineOfProduction);

    this.router.navigateByUrl(`factory/panel/company/${this.urlCompany}/status/${urlStatus}/lineOfProduction/${urlLineOfProduction}`)
  }

  private RedirectManufacturingOrder() {
    let filtro_linhas_tic = ["CO", "FI", "FT", "GA", "PH", "PI", "PL", "RV", "ST", "TE"];
    let filtro_linhas_tj = ["EQ", "FX", "JC", "MB", "MT", "PE", "RJ", "SV", "TT"];

    let urlStatus = 'all';
    let urlLineOfProduction = null;

    if (this._params.find(x => x.name == "company") !== undefined && this._params.find(x => x.name == "company").value !== 'all')
      this.urlCompany = this._params.find(x => x.name == "company").value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "lineOfProduction") !== undefined)
      urlLineOfProduction = this._params.find(x => x.name == "lineOfProduction").value;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    if (urlLineOfProduction !== this.authService.getClaims().IdLineOfProductSelected)
      this.authorizationService.selectLineOfProduct(urlLineOfProduction);

    this.router.navigateByUrl(`manufacturing-order/panel/company/${this.urlCompany}/status/${urlStatus}/lineOfProduction/${urlLineOfProduction}`)
  }

  private RedirectRequest() {
    let urlStatus = 'all';

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "company") !== undefined && this._params.find(x => x.name == "company").value !== 'all')
      this.urlCompany = this._params.find(x => x.name == "company").value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    this.router.navigateByUrl(`request/panel/company/${this.urlCompany}/status/${urlStatus}`)
  }

  private RedirectConformityCertificate() {

    if (this._params.find(x => x.name == "company") !== undefined && this._params.find(x => x.name == "company").value !== 'all')
      this.urlCompany = this._params.find(x => x.name == "company").value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    this.router.navigateByUrl(`conformity-certificate/panel/company/${this.urlCompany}`)
  }

  private RedirectRevenue(): void {
    let urlStatus = 'boleta-liberado';
    let urlFilter = 'all';
    let urlValue: any = 'all';

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "company") !== undefined && this._params.find(x => x.name == "company").value !== 'all')
      this.urlCompany = this._params.find(x => x.name == "company").value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this._params.find(x => x.name == "filter") !== undefined)
      urlFilter = this._params.find(x => x.name == "filter").value;

    if (this._params.find(x => x.name == "value") !== undefined)
      urlValue = this._params.find(x => x.name == "value").value;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    this.router.navigateByUrl(`revenue/panel/company/${this.urlCompany}/status/${urlStatus}/filter/${urlFilter}/value/${urlValue.toString().replaceAll("/", "%2F",)}`)
  }

  private RedirectTeaditStore() {
    let urlmodule = 'ticket';

    if (this._params.find(x => x.name == "module") !== undefined && this._params.find(x => x.name == "module").value !== 'all')
      urlmodule = this._params.find(x => x.name == "module").value;

    this.router.navigateByUrl(`teadit-store/module/${urlmodule}/panel`)
  }

  private RedirectEmbalagens() {
    let urlmodule = 'shipping-packing';

    if (this._params.find(x => x.name == "module") !== undefined && this._params.find(x => x.name == "module").value !== 'all')
      urlmodule = this._params.find(x => x.name == "module").value;

    this.router.navigateByUrl(`embalagens/${urlmodule}/panel`);
  }

  private RedirectOpportunity() {
    let urlStatus = 'all';
    let urlCompanyGroup = 'all';
    let urlMarket = this.authService.getClaims().MarketDefault;

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "market") !== undefined)
      urlMarket = this._params.find(x => x.name == "market").value;

    if (this._params.find(x => x.name == "company-group") !== undefined)
      urlCompanyGroup = this._params.find(x => x.name == "company-group").value;


    this.router.navigateByUrl(`opportunity/panel/market/${urlMarket}/company-group/${urlCompanyGroup}/status/${urlStatus}`)
  }

  private RedirectCustomerDateChange() {
    let urlStatus = 'all';
    let urlLineOfProduction = this.authService.getClaims().IdLineOfProductSelected;

    if (this._params.find(x => x.name == "status") !== undefined)
      urlStatus = this._params.find(x => x.name == "status").value;

    if (this._params.find(x => x.name == "company") !== undefined && this._params.find(x => x.name == "company").value !== 'all')
      this.urlCompany = this._params.find(x => x.name == "company").value;

    if (this.urlCompany == undefined)
      this.urlCompany = this.authService.getClaims().IdCompanySelected;

    if (this._params.find(x => x.name == "lineOfProduction") !== undefined)
      urlLineOfProduction = this._params.find(x => x.name == "lineOfProduction").value;

    if (this.urlCompany !== this.authService.getClaims().IdCompanySelected)
      this.authorizationService.selectCompany(this.urlCompany);

    if (urlLineOfProduction !== this.authService.getClaims().IdLineOfProductSelected)
      this.authorizationService.selectLineOfProduct(urlLineOfProduction);

    this.router.navigateByUrl(`customer-date-change/panel/company/${this.urlCompany}/linha/${urlLineOfProduction}/status/${urlStatus}`)
  }

}
